import React, { Component } from 'react'
import Axios from 'axios'
import { SYSTEM_STATS } from '../../config/rest_endpoints'
import { getUser } from '../../actions/session'
import ProgressBar from 'react-bootstrap/ProgressBar'

class SystemStats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            data: [],
            TodayInTotalCallDuration:'',
            TodayInTotalSuccessfulCalls:'',
            TodayInTotalDialedCalls:'',
            TodayInBilledCallDuration:'',
            TodayOutTotalCallDuration:'',
            TodayOutTotalSuccessfulCalls:'',
            TodayOutTotalDialedCalls:'',
            TodayOutBilledCallDuration:'',
        }
    }

    componentDidMount() {
        this.getSystemMonitor()
    }

    getSystemMonitor() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(SYSTEM_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    data: resp,
                    TodayInTotalCallDuration:resp.todayInTotalCallDuration,
                    TodayInTotalSuccessfulCalls:resp.todayInTotalSuccessfulCalls,
                    TodayInTotalDialedCalls:resp.todayInTotalDialedCalls,
                    TodayInBilledCallDuration:resp.todayInBilledCallDuration,
                    TodayOutTotalCallDuration:resp.todayOutTotalCallDuration,
                    TodayOutTotalSuccessfulCalls:resp.todayOutTotalSuccessfulCalls,
                    TodayOutTotalDialedCalls:resp.todayOutTotalDialedCalls,
                    TodayOutBilledCallDuration:resp.todayOutBilledCallDuration

                })
                console.log('res :>> ', resp);
            }
        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    render() {
        const { data,TodayInTotalCallDuration,TodayOutTotalCallDuration,TodayOutTotalSuccessfulCalls,TodayOutTotalDialedCalls,TodayInTotalDialedCalls,TodayInTotalSuccessfulCalls,TodayInBilledCallDuration,TodayOutBilledCallDuration } = this.state
      
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card card-body border-top-success border-bottom-success text-center rounded-0">

                        <div className="card-header header-elements-inline">
                            <h6 className="card-title">Incoming System Stats</h6>

                            <div className="header-elements">
                                <div><span className="badge badge-mark border-success mr-2"></span> Operational</div>
                            </div>
                        </div>

                        <div className="card-body">
                            <ul className="list-unstyled mb-0">
                                <li className="mb-3">
                                <div className="d-flex align-items-center mb-1">Total Minutes Spent <span className="text-muted ml-auto">{TodayInTotalCallDuration == "0" ? 0 :TodayInTotalCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalCallDuration} variant="danger"  style={{ height: '0.5rem' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1">Total Billed Duration <span className="text-muted ml-auto">{TodayInBilledCallDuration == "0" ? 0 : TodayInBilledCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInBilledCallDuration} variant="info"  style={{ height: '0.5rem' }} />
                                </li>
                                <li className="mb-3">
                                <div className="d-flex align-items-center mb-1">Total Successful Calls <span className="text-muted ml-auto">{TodayInTotalSuccessfulCalls == "0" ? 0 : TodayInTotalSuccessfulCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalSuccessfulCalls} variant="success"  style={{ height: '0.5rem' }} />
                                </li>

                                <li className="">
                                    <div className="d-flex align-items-center mb-1">Total Dialed Calls <span className="text-muted ml-auto">{TodayInTotalDialedCalls == "0" ? 0 : TodayInTotalDialedCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalDialedCalls} variant="info"  style={{ height: '0.5rem' }} />
                                </li>

                              
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card card-body border-top-success border-bottom-success text-center rounded-0">

                        <div className="card-header header-elements-inline">
                            <h6 className="card-title">Outgoing System Stats</h6>

                            <div className="header-elements">
                                <div><span className="badge badge-mark border-success mr-2"></span> Operational</div>
                            </div>
                        </div>

                        <div className="card-body">
                        <ul className="list-unstyled mb-0">
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1">Total Minutes Spent <span className="text-muted ml-auto">{TodayOutTotalCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalCallDuration} variant="danger"  style={{ height: '0.5rem' }} />
                                </li>

                                <li  className="mb-3">
                                    <div className="d-flex align-items-center mb-1">Total Billed Duration <span className="text-muted ml-auto">{TodayOutBilledCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutBilledCallDuration} variant="info"  style={{ height: '0.5rem' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1">Total Successful Calls <span className="text-muted ml-auto">{TodayOutTotalSuccessfulCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalSuccessfulCalls} variant="success"  style={{ height: '0.5rem' }} />
                                </li>

                                <li>
                                    <div className="d-flex align-items-center mb-1">Total Dialed  Calls <span className="text-muted ml-auto">{TodayOutTotalDialedCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalDialedCalls} variant="info"  style={{ height: '0.5rem' }} />
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SystemStats